export default __webpack_public_path__ + "static/media/Bracers of the Ecliptic.89f71218.jpg";